export function lazyComponentLoader (promise, displayError = false) {
  return () => new Promise((resolve, reject) => {
    promise
      .then(response => resolve(response))
      .catch(() => {
        if (displayError) {
          window.displayError()
          window.logError()
        }
      })
  })
}

/**
 * @param fn Callback функция
 * @param times Кол-во раз повторять попытку
 * @param interval Интервал, через какое время повторять
 * @returns {Promise<unknown>}
 */
export function retry (fn, times = 10, interval = 1000) {
  return new Promise((resolve, reject) => {
    fn()
      .then(resolve)
      .catch((error) => {
        setTimeout(() => {
          if (times === 1) {
            reject(error)

            return
          }

          retry(fn, times - 1, interval)
            .then(resolve, reject)
        }, interval)
      })
  })
}
